import axios from "axios";
import storage from "redux-persist/lib/storage";
import { OrderPayload } from "../interfaces/apiPayloads";


const MachineId = null;
const TypeMachine = 4;

export const establishmentAxiosInstance = axios.create({});

establishmentAxiosInstance.interceptors.request.use(
  async (config: any) => {
    const establishementToken = await storage.getItem("establishementToken");
    //const establishementToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI0Y2JlYmM3NC01NTQwLTQyOGMtODA2Zi1jOGRjY2Y0NzJjMmEiLCJuYW1lIjoiU2FnaHJvdW4iLCJyb2xlIjoiIiwibmJmIjoxNzExMzcyMzI2LCJleHAiOjE3MTE5NzcxMjYsImlhdCI6MTcxMTM3MjMyNiwiaXNzIjoiU2VjdXJlQXBpIiwiYXVkIjoiU2VjdXJlQXBpVXNlciJ9.feb1bmyHVkaohdv_nmTR2AijcHtB6HhRL4WWNe5kRyc";
    config.headers = {
      ...config.headers,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Credentials": "true",
      "CompanyId": localStorage.getItem("companyId") || "",

    };

    if (establishementToken) {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        Authorization: `bearer ${establishementToken}`,
      };
    } else {
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export const userAxiosInstance = axios.create({});

userAxiosInstance.interceptors.request.use(
  async (config: any) => {
    const accessToken = await storage.getItem("accessToken");
    config.headers = {
      ...config.headers,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "*",
      "Access-Control-Allow-Credentials": "true",
      "CompanyId": localStorage.getItem("companyId") || "",
    };


    if (accessToken) {
      config.headers = {
        ...config.headers,
        "Content-Type": "application/json",
        Authorization: `bearer ${accessToken}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const catalogueApi = {
  getCategories: (
    urlAzure: string
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    return establishmentAxiosInstance.get(
      `${baseUrlCatalog}/Category/GetCategoriesByIdPosAndTypeMachineId?UrlAzure=${urlAzure}&MachineId=${MachineId}&TypeMachine=${TypeMachine}`
    );
  },

  getCategoryDetails: (
    categoryId: number,
    urlAzure: string
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/Category/GetCategoryDetailsByCategoryIdAndTypeMachine?CategoryId=${categoryId}&UrlAzure=${urlAzure}&MachineId=${MachineId}&TypeMachine=${TypeMachine}`;
    return establishmentAxiosInstance.get(url);
  },

  GetSubMenu: (
    categoryId: number,
    menuId: string,
    urlAzure: string
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/Menu/GetSubMenuByCategoryIdMenuIdAndTypeMachine?CategoryId=${categoryId}&MenuId=${menuId}&UrlAzure=${urlAzure}&MachineId=${MachineId}&TypeMachine=${TypeMachine}`;
    return establishmentAxiosInstance.get(url);
  },

  GetLevelsByMenuId: (
    categoryId: string | undefined,
    menuId: number,
    urlAzure: string,
    ListMenus: string
  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/Menu/GetMenuDetailsByCategoryIdMenuIdAndTypeMachine?CategoryId=${categoryId}&MenuId=${menuId}&UrlAzure=${urlAzure}&MachineId=${MachineId}&TypeMachine=${TypeMachine}&ListMenus=${ListMenus}`;
    return establishmentAxiosInstance.get(url);
  },

  GetArticleComposition: (
    artileId: number,
    isLevelArticle: boolean,
    urlAzure: string

  ) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/Article/GetArticleCompositionByArticleId?ArticleId=${artileId}&IsLevelArticle=${isLevelArticle}&UrlAzure=${urlAzure}`;
    return establishmentAxiosInstance.get(url);
  },

  GetArticleById: (artileId: number, categoryId: number, establishmentId: number) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/Article/GetArticleByIdForFioEat?ArticleId=${artileId}&CategoryId=${categoryId}&EstablishmentId=${establishmentId}`;
    return establishmentAxiosInstance.get(url);
  },

  GetMenuById: (artileId: number) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/Menu/GetMenuByIdForFIOEat?MenuId=${artileId}`;
    return establishmentAxiosInstance.get(url);
  },

  SavedOrder: (orderPayload: OrderPayload) => {
    const url = `http://showroom1.frenchinnov.fr:150/api/applis/Command/AnticipateExternCommand`;
    return establishmentAxiosInstance.post(url, orderPayload);
  },

  getEstablishementToken: (urlAzure: string) => {
    const baseUrlCatalog = localStorage.getItem("api_catalogue");
    const url = `${baseUrlCatalog}/v1/getEstablishementToken?establishementUrl=${urlAzure}`
    return establishmentAxiosInstance.get(url);
  },

};  
